import React from "react";
import {EventPage} from "./EventPage";

export default ()=>{
    return (<EventPage/>)
}